import { createContext } from 'react';

import { getUpdatedOrPrependedList } from '../../helpers/list';

const initialTransactions = [];
const TransactionContext = createContext(initialTransactions);
const transactionReducer = (state, action) => {
  if (!action) { throw Error('transactionReducer() - action argument was falsey'); }
  switch (action.type) {
    case 'push':
      return [...state, ...action.payload];
    case 'add':
      return getUpdatedOrPrependedList(state, action.payload);
    case 'change':
      return getUpdatedOrPrependedList(state, action.payload);
    case 'reset':
      return [];
    default:
      throw Error(`Action ${action.type} not implemented`);
  }
};

export { TransactionContext, transactionReducer };
